import { TAddressComponentType, TAddressed } from './types'

/**
 * Find an address component by its type label and return its `longName` ('' if none).
 *
 * @param placeDetails anything carrying `addressComponents` — a property, place or Lightstone result
 * @param detail the component type label, e.g. `'StreetNumber'`, `'AdministrativeArea'`
 * @param detailIndex `1` takes the *last* matching component instead of the first. Google lists
 *   the most specific component first, so the last `AdministrativeArea` is the province, and the
 *   last `BuildingName` / `UnitNumber` is the one entered on the property rather than on the place.
 * @param value optional extra test on the matching type's `value`
 */
export const searchPlaceDetails = (
  placeDetails: TAddressed,
  detail: string,
  detailIndex?: number,
  value?: (value: TAddressComponentType['value']) => boolean,
): string => {
  const matches = (type: TAddressComponentType) => type.label === detail && (value === undefined || value(type.value))
  const components = (placeDetails.addressComponents ?? []).filter(component => component.types.some(matches))
  const component = detailIndex === 1 ? components[components.length - 1] : components[0]
  return component === undefined ? '' : component.longName
}
